export const createActionType = (actionPrefix: string, action: string) => `${actionPrefix}/${action}`;
